import { FC, useEffect } from 'react';
import { useUpdateUserMutation } from '../../graphql/generated/operations/user.ts';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { SubmitButton } from '../../components/forms/submit.button.tsx';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';
import { Container, Stack, Typography } from '@mui/material';
import { RadioGroupInput } from '../../components/forms/radio-group.tsx';
import { TextInput } from '../../components/forms/text-input.tsx';
import { trackEvent } from '../../utils/analytics.ts';

const initialValues = {
  age: undefined,
  gender: undefined
};

const genderChoices: string[] = ['Male', 'Female', 'Non-binary or Other'];

const validationSchema = yup.object({
  age: yup.number().required('Age is required').min(10).max(100),
  gender: yup.string().required('Gender is required')
});

export const UserInfoPage: FC = () => {
  const [updateUser, { data }] = useUpdateUserMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      navigate(Paths.STUDY_QUESTIONS);
    }
  }, [data]);

  return (
    <Container>
      <Typography variant="h4" sx={{ my: 4 }}>
        Basic Info
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          trackEvent('user_info_submit');
          await updateUser({
            variables: {
              user: {
                age: values.age + '',
                gender: values.gender
              }
            }
          });
        }}
      >
        <Form>
          <Stack gap={4} sx={{ width: '100%' }}>
            <TextInput name="age" label="Age" type="number" />
            <RadioGroupInput name="gender" label="Gender" options={genderChoices} />
            <SubmitButton> Next </SubmitButton>
          </Stack>
        </Form>
      </Formik>
    </Container>
  );
};
